import { UserShort } from "./types";

export const getFullName = (user?: UserShort | null) =>
  user ? ` ${user.first_name} ${user.last_name}` : "";
